export default {
      id: "ind-move-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#ind-move",
      toString: function () {
        return this.url;
      }
    }